gl-map {
  display: block;
  height: 100%;
  width: 100%;
}
